import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { environment } from '../../../../../environments/environment';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  control: FormControl;
  forgotPasswordFormSubmitted: boolean;
  multipleAccount: boolean;
  environment = environment;
  brand?: string;
  vitrineUrl?: string;
  errorMessageReset: string|null;

  breadcrumbDetails: any = [
    {
      url: environment.data.vitrineUrl,
      label: `Accueil`
    },
    {
      url: `/connexion`,
      label: `Identification`
    },
    {
      url: null,
      label: `Mot de passe oublié`
    }
  ];

  constructor(
      private store: Store<any>,
      private router: Router,
      private formBuilder: FormBuilder,
      private loginService: LoginService
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.vitrineUrl = environment.data.vitrineUrl;
    this.forgotPasswordFormSubmitted = false;
    this.multipleAccount = false;
    this.errorMessageReset = null;
    this.initForms();
  }

  initForms() {
    this.control = this.formBuilder.control('', Validators.required);
    this.forgotPasswordForm = this.formBuilder.group({});
    this.forgotPasswordForm.addControl('login', this.formBuilder.control('', [Validators.required]));
    this.forgotPasswordForm.addControl('phoneNumber', this.formBuilder.control('', [Validators.pattern('^(\\+33|0)[1-9][0-9]{8}$')]));
  }

  send() {
    this.forgotPasswordFormSubmitted = true;
    this.errorMessageReset = null;
    if (this.multipleAccount) {
      this.forgotPasswordForm.controls['phoneNumber'].setValidators([Validators.required, Validators.pattern('^(\\+33|0)[1-9][0-9]{8}$')]);
      this.forgotPasswordForm.controls['phoneNumber'].updateValueAndValidity();
    }
    if (this.forgotPasswordForm.valid) {
      if (
          ConstsHelper.emailPattern.test(this.forgotPasswordForm.get('login').value) ||
          ConstsHelper.phoneNumberPattern.test(this.forgotPasswordForm.get('login').value)
      ) {
        this.forgotPasswordFormSubmitted = false;
        this.loginService.forgotPassword(this.forgotPasswordForm.get('login').value, this.forgotPasswordForm.get('phoneNumber').value).subscribe(
            response => {
              if (response.message === 'multiple_accounts') {
                this.multipleAccount = true;
              } else {
                const alertMessage = ({
                  message: 'Un email vous a été envoyé pour changer votre mot de passe.',
                  code: 200
                }) as AlertMessageInterface;
                this.store.dispatch(new GetAlertMessage(alertMessage));
                this.router.navigate(['/connexion']);
              }
            }, error => {
              const alertMessage = ({
                message: ConstsHelper.ERROR_OCCURRED_RETRY_MESSAGE,
                code: 400
              }) as AlertMessageInterface;
              this.store.dispatch(new GetAlertMessage(alertMessage));
              this.initForms();
            }
        );
      } else {
        this.errorMessageReset = 'Le numéro de téléphone ou l\'adresse email  n\'est pas valide.';
      }
    }
  }

  backToLoginPage() {
    this.router.navigate(['/connexion']);
  }
}
